import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class DealerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };

        const { dealerStore, brandStore } = this.props.stores;
        dealerStore.updateSort('-last_activity');
        dealerStore.list(false, { addData: ['countries'] });

        brandStore.load();
    }

    // toggleQueryfilter(filter, value = 1, opt = {}) {
    //     const { dealerStore } = this.props.stores;
    //     const { queryFilter } = dealerStore;
    //     const finalFilter = { ...queryFilter };
    //     if (opt.setValue) {
    //         finalFilter[filter] = value;
    //     } else {
    //         finalFilter[filter] = finalFilter[filter] ? null : value;
    //     }
    //     if (!finalFilter[filter]) {
    //         delete finalFilter[filter];
    //     }
    //     dealerStore.updateQueryFilter(finalFilter);
    //     if (!opt.skipUpdate) {
    //         dealerStore.list();
    //     }
    //     if (opt.viewElement) {
    //         this.toggleView(opt.viewElement);
    //     }
    //     if (opt.setTimer) {
    //         clearTimeout(this.searchTimer);
    //         this.searchTimer = setTimeout(async () => {
    //             dealerStore.list();
    //         }, 750);
    //     }
    // }

    toggleView(element) {
        const { view } = this.state;
        view[element] = !view[element];
        this.setState({ view });
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { dealerStore } = this.props.stores;
        const { totalAppend, limit } = dealerStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = dealerStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                dealerStore.updateOffset(offset);
                await dealerStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const { loading, view } = this.state;
        const { dealerStore, brandStore } = this.props.stores;
        const { dealers, countries, queryFilter, languages } = dealerStore;
        const { brands } = brandStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {dealerStore.total}<br />
                        </small>

                        <div class='btn-group mr-2' role='group'>
                            <button id='btnGroupCountries' type='button' class='btn btn-sm btn-secondary dropdown-toggle'
                                data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                                onClick={() => this.toggleView('countries')}
                            >
                                {queryFilter.country ? queryFilter.country : 'Countries'}
                            </button>
                            <div class={`dropdown-menu ${view.countries ? 'show' : 'hide'}`} aria-labelledby='btnGroupCountries'>
                                <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('country', null, { setValue: true, viewElement: 'countries' })}>All countries</div>
                                {countries.map(country => (
                                    <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('country', country, { setValue: true, viewElement: 'countries' })}>{country}</div>
                                ))}
                            </div>
                        </div>

                        <div class='btn-group mr-2' role='group'>
                            <button id='btnGroupLanguages' type='button' class='btn btn-sm btn-secondary dropdown-toggle'
                                data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                                onClick={() => this.toggleView('languages')}
                            >
                                {queryFilter.language ? queryFilter.language : 'Languages'}
                            </button>
                            <div class={`dropdown-menu ${view.languages ? 'show' : 'hide'}`} aria-labelledby='btnGroupLanguages'>
                                <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('language', null, { setValue: true, viewElement: 'languages' })}>All languages</div>
                                {Object.keys(languages).map((language) => {
                                    const lang = languages[language];
                                    return (
                                        <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('language', lang, { setValue: true, viewElement: 'languages' })}>{language}</div>
                                    );
                                })}
                            </div>
                        </div>

                        <div class='btn-group mr-2' role='group'>
                            <button id='btnGroupBrand' type='button' class='btn btn-sm btn-secondary dropdown-toggle'
                                data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                                onClick={() => this.toggleView('brands')}
                            >
                                {queryFilter.brand ? queryFilter.brand : 'Brands'}
                            </button>
                            <div class={`dropdown-menu ${view.brands ? 'show' : 'hide'}`} aria-labelledby='btnGroupBrand'>
                                <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('brand', null, { setValue: true, viewElement: 'brands' })}>All brands</div>
                                {brands.map(brand => (
                                    <div class={`dropdown-item ${style.pointerCursor}`} onClick={() => dealerStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, viewElement: 'brands' })}>{brand.name}</div>
                                ))}
                            </div>
                        </div>

                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.terms)}`}
                            onClick={() => dealerStore.toggleQueryfilter('terms', util.cyclevalues(queryFilter.terms, [null, 1, -1]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.terms ? 'on' : 'off'} mr-1`} />
                            Terms
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.is_agent)}`}
                            onClick={() => dealerStore.toggleQueryfilter('is_agent', util.cyclevalues(queryFilter.is_agent, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.is_agent ? 'on' : 'off'} mr-1`} />
                            Agent
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.locator)}`}
                            onClick={() => dealerStore.toggleQueryfilter('locator', util.cyclevalues(queryFilter.locator, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.locator ? 'on' : 'off'} mr-1`} />
                            Locator
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.approved)}`}
                            onClick={() => dealerStore.toggleQueryfilter('approved', util.cyclevalues(queryFilter.approved, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.approved ? 'on' : 'off'} mr-1`} />
                            Approved
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.confirmed)}`}
                            onClick={() => dealerStore.toggleQueryfilter('confirmed', util.cyclevalues(queryFilter.confirmed, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.confirmed ? 'on' : 'off'} mr-1`} />
                            Confirmed
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.darkmode)}`}
                            onClick={() => dealerStore.toggleQueryfilter('darkmode', util.cyclevalues(queryFilter.darkmode, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.darkmode ? 'on' : 'off'} mr-1`} />
                            Darkmode
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasAccessToCombos)}`}
                            onClick={() => dealerStore.toggleQueryfilter('hasAccessToCombos', util.cyclevalues(queryFilter.hasAccessToCombos, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.hasAccessToCombos ? 'on' : 'off'} mr-1`} />
                            Combos
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.acceptCustomerOrders)}`}
                            onClick={() => dealerStore.toggleQueryfilter('acceptCustomerOrders', util.cyclevalues(queryFilter.acceptCustomerOrders, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.acceptCustomerOrders ? 'on' : 'off'} mr-1`} />
                            Customer orders
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.shipping)}`}
                            onClick={() => dealerStore.toggleQueryfilter('shipping', util.cyclevalues(queryFilter.shipping, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.shipping ? 'on' : 'off'} mr-1`} />
                            Shipping
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.store)}`}
                            onClick={() => dealerStore.toggleQueryfilter('store', util.cyclevalues(queryFilter.store, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.store ? 'on' : 'off'} mr-1`} />
                            Store
                        </button>
                        <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.backorders)}`}
                            onClick={() => dealerStore.toggleQueryfilter('backorders', util.cyclevalues(queryFilter.backorders, [null, 1, 0]), { setValue: 1 })}
                        >
                            <i class={`fas fa-toggle-${queryFilter.backorders ? 'on' : 'off'} mr-1`} />
                            Backorders
                        </button>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for dealers...'
                                    onInput={e => dealerStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => dealerStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {dealerStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => dealerStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {dealerStore.sort !== dealerStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => dealerStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 65%'>
                                            <span class={style.pointerCursor} onClick={() => dealerStore.toggleSort('name', '-')}>
                                                Name {util.getSortIcon('name', dealerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-center'>
                                            <span class={style.pointerCursor} onClick={() => dealerStore.toggleSort('locator', '-')}>
                                                Locator {util.getSortIcon('locator', dealerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class=''>
                                            <span class={style.pointerCursor} onClick={() => dealerStore.toggleSort('status', '-')}>
                                                Status {util.getSortIcon('status', dealerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class=''>
                                            <span class={style.pointerCursor} onClick={() => dealerStore.toggleSort('last_activity', '-')}>
                                                Last login / Last activity {util.getSortIcon('last_activity', dealerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => dealerStore.toggleSort('api_activity', '-')}>
                                                Logins / Activities {util.getSortIcon('api_activity', dealerStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            Basket
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dealers && dealers.map(dealer => (
                                        <tr class={`${style.tableline}`}>
                                            <td class=''>

                                                <span class='float-right text-muted'>
                                                    <small>
                                                        {dealer.country} {dealer.pricelistno}
                                                    </small>
                                                </span>
                                                {dealer.is_agent && dealer.agent_dealers && <span class={`mr-2 text-muted`}>
                                                    <i class='fas fa-user-secret' /> ({dealer.agent_dealers.length})
                                                </span>}

                                                <a href={`/dealers/${dealer.customerno}/Basics`}>
                                                    {dealer.customerno}: {dealer.name}
                                                    <span class='text-muted ml-2'>
                                                        <small>
                                                            ({dealer.email})
                                                        </small>
                                                    </span>
                                                </a>
                                                <small class='float-right'>
                                                    {dealer.isOnline && <span class={`mr-2 badge badge-pill badge-info`}>
                                                        Online
                                                    </span>}
                                                    {dealer.isOnlineApi && <span class={`mr-2 badge badge-pill badge-success text-white`}>
                                                        Online API
                                                    </span>}
                                                    {dealer.settings && dealer.settings.darkmode === 1 && <span class={`mr-2 badge badge-pill badge-secondary text-warning`}>
                                                        <i class='fas fa-moon' /> Darkmode
                                                    </span>}
                                                    {dealer.settings && dealer.settings.language && <span class={`mr-2 badge badge-pill text-muted`}>
                                                        <i class='fas fa-flag' /> {dealer.settings.language}
                                                    </span>}
                                                </small>
                                                <div>
                                                    <small>
                                                        {brands && brands.map((brand) => {
                                                            const nested = util.checkNested(dealer, 'brands', brand.brandno, 'allowed');
                                                            const allowed = nested && dealer.brands[brand.brandno].allowed;
                                                            const badgeStyle = nested && allowed ? 'badge-success' : 'btn-outline-success';
                                                            const brandAllowed = nested && util.asBoolean(dealer, 'brands', brand.brandno, 'allowed');
                                                            return (
                                                                <span
                                                                    class={`mr-1 badge ${badgeStyle} ${style.pointerCursor}`}
                                                                    data-brandno={brand.brandno}
                                                                    data-customerno={dealer.customerno}
                                                                    onClick={() => dealerStore.saveField(dealer.customerno, `brands.${brand.brandno}.allowed`, !brandAllowed, true)}
                                                                >
                                                                    {brand.name}
                                                                </span>
                                                            );
                                                        })}
                                                    </small>
                                                </div>
                                                <div>
                                                    <small>
                                                        {brands && brands.map((brand) => {
                                                            const nested = util.checkNested(dealer, 'brandCombos', brand.brandno, 'allowed');
                                                            const allowed = nested && dealer.brandCombos[brand.brandno].allowed;
                                                            const badgeStyle = nested && allowed ? 'badge-primary' : 'btn-outline-primary';
                                                            const brandAllowed = nested && util.asBoolean(dealer, 'brandCombos', brand.brandno, 'allowed');
                                                            return (
                                                                <span
                                                                    class={`mr-1 badge ${badgeStyle} ${style.pointerCursor}`}
                                                                    data-brandno={brand.brandno}
                                                                    data-customerno={dealer.customerno}
                                                                    onClick={() => dealerStore.saveField(dealer.customerno, `brandCombos.${brand.brandno}.allowed`, !brandAllowed, true)}
                                                                >
                                                                    {brand.name}
                                                                </span>
                                                            );
                                                        })}
                                                    </small>
                                                </div>

                                                <small class={`mr-2 text-muted font-weight-lighter`}>Downloads:</small>
                                                {Object.keys(dealer.csvDownloads || {}).map(brand => (
                                                    <small class={`mr-2 text-muted font-weight-lighter`}>
                                                        <i class='fas fa-file-csv' /> {brand}: {dealer.csvDownloads[brand]}
                                                    </small>
                                                ))}

                                            </td>
                                            <td class='text-center'>
                                                <small>
                                                    <span
                                                        class={`mr-1 badge ${style.pointerCursor} ${dealer.locator ? 'badge-success' : 'btn-outline-secondary'}`}
                                                        onClick={() => dealerStore.saveField(dealer.customerno, `locator`, dealer.locator ? 0 : 1, true)}
                                                    >
                                                        <i class={`fas fa-toggle-${dealer.locator ? 'on' : 'off'}`} />
                                                        &nbsp;<i class='fas fa-map-marker-alt' /> {dealer.locator ? 'Yes' : 'No'}
                                                    </span>
                                                </small>
                                            </td>
                                            <td class=''>

                                                <small>
                                                    <nobr>
                                                        <span
                                                            class={`mr-1 badge ${style.pointerCursor} badge-${dealer.confirmed ? 'success' : 'danger'}`}
                                                            onClick={() => dealerStore.saveField(dealer.customerno, `confirmed`, dealer.confirmed ? 0 : 1, true)}
                                                        >
                                                            <i class={`fas fa-toggle-${dealer.confirmed === 1 ? 'on' : 'off'}`} />
                                                            &nbsp;<i class='fas fa-check' /> Confirmed
                                                        </span>
                                                        <span
                                                            class={`mr-1 badge ${style.pointerCursor} badge-${dealer.approved ? 'success' : 'danger'}`}
                                                            onClick={() => dealerStore.saveField(dealer.customerno, `approved`, dealer.approved ? 0 : 1, true)}
                                                        >
                                                            <i class={`fas fa-toggle-${dealer.approved === 1 ? 'on' : 'off'}`} />
                                                            &nbsp;<i class='fas fa-thumbs-up' /> Approved
                                                        </span>
                                                    </nobr>
                                                    <br />
                                                    <nobr>
                                                        <span
                                                            class={`mr-1 badge ${style.pointerCursor} ${dealer.settings.acceptCustomerOrders ? 'badge-success' : 'btn-outline-secondary'}`}
                                                            onClick={() => dealerStore.saveField(dealer.customerno, `settings.acceptCustomerOrders`, dealer.settings.acceptCustomerOrders ? 0 : 1, true)}
                                                        >
                                                            <i class={`fas fa-toggle-${dealer.settings.acceptCustomerOrders === 1 ?
                                                                'on' : 'off'}`} />
                                                            &nbsp;<i class='fas fa-shopping-cart' /> CustOrders
                                                        </span>
                                                        <span
                                                            class={`mr-1 badge ${style.pointerCursor} ${dealer.hasAccessToCombos ? 'badge-success' : 'btn-outline-secondary'}`}
                                                            onClick={() => dealerStore.saveField(dealer.customerno, `hasAccessToCombos`, dealer.hasAccessToCombos ? 0 : 1, true)}
                                                        >
                                                            <i class={`fas fa-toggle-${dealer.hasAccessToCombos === 1 ?
                                                                'on' : 'off'}`} />
                                                            &nbsp;<i class='fas fa-box-open' /> Combos
                                                        </span>
                                                    </nobr>
                                                    <br />
                                                    <nobr>
                                                        {Object.keys(dealer.termsAndConditions || {}).map(ver => (
                                                            <span
                                                                class={`mr-1 badge ${style.pointerCursor} ${dealer.termsAndConditions[ver].acceptedDate ? 'badge-success' : 'btn-outline-secondary'}`}
                                                                onClick={() => dealerStore.saveField(dealer.customerno, `termsAndConditions.${ver}.acceptedDate`, dealer.termsAndConditions[ver].acceptedDate ? 0 : new Date(), true)}
                                                            >
                                                                <i class={`fas fa-toggle-${dealer.termsAndConditions[ver].acceptedDate ? 'on' : 'off'}`} />
                                                                &nbsp;<i class='fas fa-signature' /> {ver}
                                                            </span>
                                                        ))}

                                                    </nobr>
                                                </small>

                                            </td>
                                            <td>

                                                <small>
                                                    <nobr><i class='text-muted fas fa-sign-in-alt mr-1' />
                                                        {util.ffeDateTime(dealer.last_login)}
                                                    </nobr>
                                                    <br />
                                                    <nobr><i class='text-muted fas fa-running mr-1' />
                                                        {util.ffeDateTime(dealer.last_activity)}
                                                    </nobr>
                                                    <br />
                                                    <nobr><i class='text-success fas fa-skiing-nordic mr-1' />
                                                        {dealer.last_api_activity ? util.ffeDateTime(dealer.last_api_activity) : 'n/a'}
                                                    </nobr>
                                                    <br />

                                                    {dealer.emails && Object.keys(dealer.emails).map((email) => {
                                                        const user = dealer.emails[email];
                                                        if (user.current_login_failed > 0) {
                                                            return (
                                                                <div class={`text-${user.current_login_failed < 5 ?
                                                                    'warning' : 'danger'}`}>
                                                                    <small class={style.pointerCursor}
                                                                        onClick={() => dealerStore.saveField(dealer.customerno, `emails.${email}.current_login_failed`, 0, true)}
                                                                    >
                                                                        <i class='fas fa-exclamation-triangle mr-1' />
                                                                        Failed logins: {user.email || dealer.email}: {user.current_login_failed}
                                                                    </small>
                                                                </div>
                                                            );
                                                        }
                                                    })}
                                                </small>

                                            </td>
                                            <td class='text-right'>

                                                <small>
                                                    {util.formatCompact(dealer.visits)}
                                                    <i class='text-muted fas fa-sign-in-alt ml-1' />
                                                    <br />
                                                    {util.formatCompact(dealer.activity)}
                                                    <i class='text-muted fas fa-running ml-1' />
                                                    <br />
                                                    {util.formatCompact(dealer.api_activity || 0)}
                                                    <i class='text-success fas fa-skiing-nordic ml-1' />
                                                </small>

                                            </td>
                                            <td class='text-right'>

                                                <small>
                                                    {dealer.basketQty > 0 && <span class='text-success'>
                                                        <nobr>{dealer.basketQty} basket items</nobr><br />
                                                        <nobr>
                                                            <small class='mr-1'>{dealer.basketCurrency}</small>
                                                            {util.format(dealer.basketTotal, 2)}
                                                        </nobr><br />
                                                    </span>}
                                                    {dealer.psBasketQty > 0 && <span class='text-warning'>
                                                        <nobr>{dealer.psBasketQty} ps basket items</nobr><br />
                                                        <nobr>
                                                            <small class='mr-1'>{dealer.psBasketCurrency}</small>
                                                            {util.format(dealer.psBasketTotal, 2)}
                                                        </nobr><br />
                                                    </span>}
                                                    {dealer.backorderCount > 0 && <span class='text-info'>
                                                        <nobr>{dealer.backorderCount} backorders {dealer.backorderProductCount} items</nobr><br />
                                                        <nobr><small class='ml-2 mr-1'>{dealer.currency}</small> {util.format(dealer.backorderProductTotal, 2)}</nobr><br />
                                                    </span>}
                                                </small>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default DealerList;




// WEBPACK FOOTER //
// ./components/dealers/list.js